import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const emailOutboxState = (state: RootState) => state.scene.emailOutbox;

export const getOutboxActiveTab = createSelector(emailOutboxState, ({ activeTab }) => activeTab);

export const getOutboxEmails = createSelector(emailOutboxState, ({ emails }) => emails);

export const getOutboxStatusCounts = createSelector(
  emailOutboxState,
  ({ statusCounts }) => statusCounts
);

export const getOutboxViewState = createSelector(emailOutboxState, ({ viewState }) => viewState);

export const isOutboxLoading = createSelector(emailOutboxState, ({ loading }) => loading);
